/**
 * Get tenant uuid
 * @param {*}
 * @return {string}
 */
export function getTenantUUID() {
  return localStorage.getItem('tenantUUID')
}
